import React from 'react';
import SEOHead from './SEOHead';
import { getOrganizationSchema, getWebSiteSchema, getMedicalServiceSchema } from './StructuredData';

// SEO configurations for different pages
export const pageSEOConfig = {
  home: {
    title: "Teledoc - Online Doctor Consultation & Telemedicine Platform | 24/7 Healthcare",
    description: "Get instant online doctor consultation with certified doctors in Gurugram, Delhi NCR, Mumbai & across India. Book video appointments and access 24/7 quality healthcare from home.",
    keywords: "online doctor consultation, telemedicine, virtual doctor, healthcare, medical consultation, doctor appointment, telemedicine platform, 24/7 doctor, online healthcare, online doctor consultation India, online doctor Gurugram, doctor via video call near me, doctor consultation Noida, telemedicine Delhi NCR, video doctor Pune, doctor consultation Kolkata, telemedicine Chennai, online doctor Bengaluru, online doctor Ahmedabad, doctor video call Hyderabad",
    canonical: "/",
    structuredData: [getOrganizationSchema(), getWebSiteSchema(), getMedicalServiceSchema()]
  },

  bookAppointment: {
    title: "Book Online Doctor Appointment | Teledoc Telemedicine Platform",
    description: "Book your online doctor appointment instantly in Noida, Pune, Bangalore & more. Consult with top certified doctors via secure video call. Get medical advice from the comfort of your home.",
    keywords: "book doctor appointment, online appointment, video consultation, telemedicine appointment, virtual doctor visit, medical consultation booking",
    canonical: "/book-appointment",
    structuredData: [getOrganizationSchema()]
  },

  whatWeTreat: {
    title: "What We Treat | Common Conditions | Teledoc Telemedicine",
    description: "Discover the wide range of medical conditions we treat through our online consultation platform. From common cold to chronic conditions, our doctors can help.",
    keywords: "medical conditions, what we treat, online treatment, telemedicine conditions, virtual consultation, medical symptoms, health conditions",
    canonical: "/what-we-treat",
    structuredData: [getOrganizationSchema()]
  },

  login: {
    title: "Login | Teledoc Telemedicine Platform",
    description: "Login to your Teledoc account to access your medical records, book appointments, and manage your healthcare online.",
    keywords: "login, patient portal, medical records, healthcare account, telemedicine login",
    canonical: "/login",
    noIndex: true
  },

  register: {
    title: "Register | Join Teledoc Telemedicine Platform",
    description: "Create your Teledoc account to start accessing online doctor consultations and telemedicine services. Quick and easy registration.",
    keywords: "register, sign up, create account, telemedicine registration, healthcare signup",
    canonical: "/register",
    noIndex: true
  },

  dashboard: {
    title: "Dashboard | My Health Records | Teledoc",
    description: "Access your personal health dashboard. View appointments, medical records, and manage your healthcare journey.",
    keywords: "health dashboard, medical records, patient portal, health management, appointment history",
    canonical: "/dashboard",
    noIndex: true
  },

  dataPrivacy: {
    title: "Data Privacy & Ethics | Teledoc Telemedicine Platform",
    description: "Learn about our commitment to data privacy, patient confidentiality, and ethical medical practices in telemedicine services.",
    keywords: "data privacy, medical ethics, patient confidentiality, telemedicine privacy, healthcare data protection",
    canonical: "/data-privacy-ethics",
    structuredData: [getOrganizationSchema()]
  },

  policies: {
    title: "Policies & Procedures | Teledoc Telemedicine Platform",
    description: "Review our comprehensive policies and procedures for telemedicine services, patient care, and platform usage guidelines.",
    keywords: "medical policies, telemedicine procedures, healthcare guidelines, platform policies, medical procedures",
    canonical: "/policies-procedures",
    structuredData: [getOrganizationSchema()]
  },

  terms: {
    title: "Terms of Use | Teledoc Telemedicine Platform",
    description: "Read our terms of use for the Teledoc telemedicine platform. Understand your rights and responsibilities when using our services.",
    keywords: "terms of use, platform terms, telemedicine terms, service agreement, user terms",
    canonical: "/terms-of-use",
    structuredData: [getOrganizationSchema()]
  },

  refund: {
    title: "Refund Policy | Teledoc Telemedicine Platform",
    description: "Learn about our refund policy for telemedicine services, appointment cancellations, and billing procedures.",
    keywords: "refund policy, cancellation policy, billing, telemedicine refunds, appointment cancellation",
    canonical: "/refund-policy",
    structuredData: [getOrganizationSchema()]
  }
};

const PageSEO = ({ page, customTitle, customDescription, customKeywords, customCanonical, structuredData, noIndex = false }) => {
  const config = pageSEOConfig[page] || pageSEOConfig.home;

  const title = customTitle || config.title;
  const description = customDescription || config.description;
  const keywords = customKeywords || config.keywords;
  const canonical = customCanonical || config.canonical;
  const finalStructuredData = structuredData || config.structuredData;

  return (
    <SEOHead
      title={title}
      description={description}
      keywords={keywords}
      canonical={canonical}
      structuredData={finalStructuredData}
      noIndex={noIndex || config.noIndex}
    />
  );
};

export default PageSEO;
